import React from 'react';
import { connect } from 'react-redux';

import S from 'constants/string.const';
import { withGilt, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import FutureRevenueProjectionsTable from 'reports/FutureRevenue/FutureRevenueProjectionsTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const ReportsProps = ['salonHoursReport', 'salesReport', 'uniqueVisitsReport', 'appointmentsReport'];

class FutureRevenueLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    let revenueData;
    const currencyAbbr = this.props.currency;
    const { uniqueVisitsReport, t, formatDate } = this.props;

    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });

      revenueData = convertStylistsMapsToStylistTableData(nameServicesTotalPriceMap, nameProductsTotalPriceMap, currencyAbbr, t);
    }

    return (
      <div className="has-protipbox">
        <div className="performance p3">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
              <div className="spinner-text">
                {t('businessReports.futureRevenue.loadingTextPart1')}{' '}
                <span role="img" aria-labelledby="nerd face emoji">
                  {S.nerdFace}
                </span>
                <br />
                {t('businessReports.futureRevenue.loadingTextPart2')}
              </div>
            </div>
          )}
          {this.checkIfAllDataIsLoaded() && revenueData && (
            <React.Fragment>
              <div className="banner default full-width kpi">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp" style={{ marginTop: '-10px' }}>
                      {S.lamp}
                    </span>
                    <div className="text">
                      <strong>{t('businessReports.futureRevenue.proTipTitle')}</strong>
                      {t('businessReports.futureRevenue.proTipDescription')}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '18px' }} />

              <FutureRevenueProjectionsTable
                startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { reports } = state;
  const { salonHoursReport, salesReport, uniqueVisitsReport, uniqueClientsReport, appointmentsReport, stylistsRequestsReport } = reports;
  const currency = selectCurrentSalonCurrency(state);
  return {
    salesReport,
    salonHoursReport,
    uniqueVisitsReport,
    uniqueClientsReport,
    appointmentsReport,
    stylistsRequestsReport,
    currency,
  };
}

export default connect(mapStateToProps, {})(withGilt(withTranslation()(FutureRevenueLayout)));
